// extracted by mini-css-extract-plugin
export default {"firstView":"styles_firstView__fG+bB"};